import React from "react";

class CheckboxField extends React.Component{
    render(){
        const that = this
        return (
            <div>
                <label class="label-over" for={this.props.id}>
                    <input
                        type="checkbox"
                        name={this.props.name}
                        id={this.props.id}
                        required={this.props.required} 
                        />
                </label>
                <label for={this.props.id} class="form__label">
                    <div class="form__help_text">
                        {this.props.label}
                        {this.props.required && (
                            <span class="chart-red">*</span>
                        )}
                    </div>
                </label>
            </div>
        )
    }
}

export default CheckboxField